import { MenuMode } from '@app/engine/core/interfaces';
import { getEl } from '@app/engine/utils/get-el';
import { keepTrackApi } from '@app/keepTrackApi';
import videoSettingsPng from '@public/img/icons/video-settings.png';
import { EventBusEvent } from '@app/engine/events/event-bus-events';
import { html } from '@app/engine/utils/development/formatter';
import { KeepTrackPlugin } from '../../engine/plugins/base-plugin';
import { SoundNames } from '../sounds/sounds';
import { EventBus } from '@app/engine/events/event-bus';
export class VideoDirectorPlugin extends KeepTrackPlugin {
    id = 'VideoDirectorPlugin';
    dependencies_ = [];
    menuMode = [MenuMode.EXPERIMENTAL, MenuMode.ALL];
    isRotateL = true;
    isRotateR = false;
    isRotateU = false;
    isRotateD = false;
    bottomIconElementName = 'video-director-icon';
    bottomIconImg = videoSettingsPng;
    sideMenuElementName = 'video-director-menu';
    sideMenuElementHtml = html `
  <div id="video-director-menu" class="side-menu-parent start-hidden text-select">
    <div id="video-director-content" class="side-menu">
      <div class="row">
        <form id="video-director-form">
          <div id="video-director-general">
            <div class="row center"></div>
            </br>
            <div class="row center">
              <button id="video-director-submit" class="btn btn-ui waves-effect waves-light" type="submit" name="action">Update video-director &#9658;</button>
            </div>
            <h5 class="center-align">General video-director</h5>
            <div class="input-field col s12">
              <input value="0.000075" id="video-director-rotateSpeed" type="text" maxlength="9" />
              <label for="video-director-rotateSpeed" class="active">Rotate Speed</label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Rotate Camera to the Left">
                <input id="video-director-rotateL" type="checkbox" checked/>
                <span class="lever"></span>
                Rotate Camera Left
              </label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Rotate Camera to the Right">
                <input id="video-director-rotateR" type="checkbox"/>
                <span class="lever"></span>
                Rotate Camera Right
              </label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Rotate Camera Up">
                <input id="video-director-rotateU" type="checkbox"/>
                <span class="lever"></span>
                Rotate Camera Up
              </label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Rotate Camera Down">
                <input id="video-director-rotateD" type="checkbox"/>
                <span class="lever"></span>
                Rotate Camera Down
              </label>
            </div>
            <div class="input-field col s12">
              <input value="0.05" id="video-director-panSpeed" type="text" maxlength="9" />
              <label for="video-director-panSpeed" class="active">Pan Speed</label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Pan Camera Left">
                <input id="video-director-panL" type="checkbox"/>
                <span class="lever"></span>
                Pan Camera Left
              </label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Pan Camera Right">
                <input id="video-director-panR" type="checkbox"/>
                <span class="lever"></span>
                Pan Camera Right
              </label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Pan Camera Up">
                <input id="video-director-panU" type="checkbox"/>
                <span class="lever"></span>
                Pan Camera Up
              </label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Pan Camera Down">
                <input id="video-director-panD" type="checkbox"/>
                <span class="lever"></span>
                Pan Camera Down
              </label>
            </div>
            <div class="input-field col s12">
              <input value="0.0005" id="video-director-zoomSpeed" type="text" maxlength="9" />
              <label for="video-director-zoomSpeed" class="active">Zoom Speed</label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Zoom Camera In">
                <input id="video-director-zoomIn" type="checkbox"/>
                <span class="lever"></span>
                Zoom Camera In
              </label>
            </div>
            <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Zoom Camera Out">
                <input id="video-director-zoomOut" type="checkbox"/>
                <span class="lever"></span>
                Zoom Camera Out
              </label>
          </div>
          <div class="switch row">
              <label data-position="top" data-delay="50" data-tooltip="Disable Selected Satellite Dot">
                <input id="video-director-selectedColor" type="checkbox"/>
                <span class="lever"></span>
                Disable Selected Satellite Dot
              </label>
          </div>
          <div class="center-align row">
            <button id="video-director-rotate" class="btn btn-ui waves-effect waves-light" type="button" name="action">Start Auto Rotate &#9658;</button>
          </div>
        </form>
      </div>
    </div>
  </div>`;
    isNotColorPickerInitialSetup = false;
    addHtml() {
        super.addHtml();
        EventBus.getInstance().on(EventBusEvent.uiManagerFinal, () => {
            getEl('video-director-form').addEventListener('change', VideoDirectorPlugin.onFormChange);
            getEl('video-director-form').addEventListener('submit', VideoDirectorPlugin.onSubmit);
            getEl('video-director-rotate').addEventListener('click', () => {
                keepTrackApi.getSoundManager()?.play(SoundNames.BUTTON_CLICK);
                keepTrackApi.getMainCamera().autoRotate(true);
            });
        });
    }
    static onFormChange(e) {
        if (typeof e === 'undefined' || e === null) {
            throw new Error('e is undefined');
        }
        const elementId = e.target?.id;
        switch (elementId) {
            case 'video-director-rotateL':
            case 'video-director-rotateR':
            case 'video-director-rotateU':
            case 'video-director-rotateD':
            case 'video-director-panL':
            case 'video-director-panR':
            case 'video-director-panU':
            case 'video-director-panD':
            case 'video-director-zoomIn':
            case 'video-director-zoomOut':
                if (getEl(elementId)?.checked) {
                    // Play sound for enabling option
                    keepTrackApi.getSoundManager()?.play(SoundNames.TOGGLE_ON);
                }
                else {
                    // Play sound for disabling option
                    keepTrackApi.getSoundManager()?.play(SoundNames.TOGGLE_OFF);
                }
                break;
            default:
                break;
        }
        if (getEl('video-director-selectedColor').checked && settingsManager.selectedColor[3] !== 0) {
            settingsManager.selectedColorFallback = settingsManager.selectedColor;
            settingsManager.selectedColor = [0, 0, 0, 0];
        }
        else {
            settingsManager.selectedColor = settingsManager.selectedColorFallback;
        }
        settingsManager.autoRotateSpeed = parseFloat(getEl('video-director-rotateSpeed').value);
        settingsManager.autoPanSpeed = parseFloat(getEl('video-director-panSpeed').value);
        settingsManager.autoZoomSpeed = parseFloat(getEl('video-director-zoomSpeed').value);
        const isRotateL = getEl('video-director-rotateL').checked;
        const isRotateR = getEl('video-director-rotateR').checked;
        const isRotateU = getEl('video-director-rotateU').checked;
        const isRotateD = getEl('video-director-rotateD').checked;
        const isPanL = getEl('video-director-panL').checked;
        const isPanR = getEl('video-director-panR').checked;
        const isPanU = getEl('video-director-panU').checked;
        const isPanD = getEl('video-director-panD').checked;
        const isZoomIn = getEl('video-director-zoomIn').checked;
        const isZoomOut = getEl('video-director-zoomOut').checked;
        if (isRotateL && !settingsManager.isAutoRotateL) {
            getEl('video-director-rotateR').checked = false;
        }
        if (isRotateR && !settingsManager.isAutoRotateR) {
            getEl('video-director-rotateL').checked = false;
        }
        if (isRotateU && !settingsManager.isAutoRotateU) {
            getEl('video-director-rotateD').checked = false;
        }
        if (isRotateD && !settingsManager.isAutoRotateD) {
            getEl('video-director-rotateU').checked = false;
        }
        if (isPanL && !settingsManager.isAutoPanL) {
            getEl('video-director-panR').checked = false;
        }
        if (isPanR && !settingsManager.isAutoPanR) {
            getEl('video-director-panL').checked = false;
        }
        if (isPanU && !settingsManager.isAutoPanU) {
            getEl('video-director-panD').checked = false;
        }
        if (isPanD && !settingsManager.isAutoPanD) {
            getEl('video-director-panU').checked = false;
        }
        if (isZoomIn && !settingsManager.isAutoZoomIn) {
            getEl('video-director-zoomOut').checked = false;
        }
        if (isZoomOut && !settingsManager.isAutoZoomOut) {
            getEl('video-director-zoomIn').checked = false;
        }
    }
    static onSubmit(e) {
        if (typeof e === 'undefined' || e === null) {
            throw new Error('e is undefined');
        }
        e.preventDefault();
        keepTrackApi.getSoundManager()?.play(SoundNames.BUTTON_CLICK);
        settingsManager.isAutoRotateR = getEl('video-director-rotateR').checked;
        settingsManager.isAutoRotateL = getEl('video-director-rotateL').checked;
        settingsManager.isAutoRotateU = getEl('video-director-rotateU').checked;
        settingsManager.isAutoRotateD = getEl('video-director-rotateD').checked;
        settingsManager.isAutoPanR = getEl('video-director-panR').checked;
        settingsManager.isAutoPanL = getEl('video-director-panL').checked;
        settingsManager.isAutoPanU = getEl('video-director-panU').checked;
        settingsManager.isAutoPanD = getEl('video-director-panD').checked;
        settingsManager.isAutoZoomIn = getEl('video-director-zoomIn').checked;
        settingsManager.isAutoZoomOut = getEl('video-director-zoomOut').checked;
    }
}
